export const EP_GET_ALL_ORDERS = 
{
    path:"order/getAllOrders",
    method:"GET"
};

export const EP_CREATE_ORDER = 
{
    path:"order/createOrder",
    method:"POST",
    requestBody: {
      "description": "lorem ipsum dolor sit amet",
      "companyBuyer": "nfwdnsdns",
      "products": [
        "prodotto0",
        "prodotto1"
      ],
      "notify": {
        "emailCustomer": "testemailcustomer@test.com",
        "emailSupplier": "testemailsupplier@test.com",
        "alreadySent": false,
        "text": ""
      }
    }
};

export const EP_DELETE_ORDER = 
{
    path:"order/deleteOrder",
    method:"DELETE",
    requestBody:{
      "description": "lorem ipsum dolor sit amet",
      "companyBuyer": "nfwdnsdns",
      "products": [
        "prodotto0",
        "prodotto1"
      ],
      "notify": {
        "emailCustomer": "testemailcustomer@test.com",
        "emailSupplier": "testemailsupplier@test.com",
        "alreadySent": false,
        "text": ""
      },
      "_id": ""
    }
};

export const EP_UPDATE_ORDER = 
{
    path:"order/updateOrder",
    method:"PATCH",
    requestBody: {
      "description": "lorem ipsum dolor sit amet",
      "companyBuyer": "nfwdnsdns",
      "products": [
        "prodotto0",
        "prodotto1"
      ],
      "notify": {
        "emailCustomer": "testemailcustomer@test.com",
        "emailSupplier": "testemailsupplier@test.com",
        "alreadySent": false,
        "text": ""
      },
      "_id": ""
    }
};

export const EP_SEARCH_ORDER = 
{
    path:"order/searchOrder",
    method:"GET",
    params: {
        _id : "0",
        description : "lorem ipsum dolor sit amet"
    }
};
